import { PeriodoContratoSummaryDto } from "@models/periodos-contrato/periodoContratoSummaryDto.model"

export class CreatePeriodoContratoRequest{
    public idContrato: number = 0
    public periodoContrato: PeriodoContratoSummaryDto[] = []
}
